var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImport = function SvgImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -10.51,
    y1: 166.48,
    x2: 151.49,
    y2: 23.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.78,
    y1: 214.39,
    x2: 193.78,
    y2: 71.39,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.89,124.68c3.48,3.48,8.19,5.43,13.11,5.43,4.92,0,9.64-1.95,13.11-5.43l39.14-39.14c2.71-2.81,2.71-7.26,0-10.07-2.78-2.88-7.37-2.96-10.25-.18l-34.76,34.76V11.23c0-4-3.24-7.25-7.25-7.25s-7.25,3.24-7.25,7.25v98.83l-34.76-34.76c-2.83-2.83-7.41-2.83-10.24,0-2.83,2.83-2.83,7.41,0,10.24l39.14,39.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.75,118.9c-4,0-7.25,3.24-7.25,7.25v50.66c0,2.6-2.11,4.72-4.72,4.72H19.21c-2.6,0-4.72-2.11-4.72-4.72v-50.66c0-4-3.24-7.25-7.25-7.25s-7.25,3.24-7.25,7.25v50.66c.01,10.6,8.61,19.2,19.21,19.21h161.58c10.6-.01,19.2-8.61,19.21-19.21v-50.66c0-4-3.24-7.25-7.25-7.25Z"
  })));
};
export default SvgImport;